//
import { Map as ImmutableMap, Record } from 'immutable';

import { DateTime } from 'luxon';

export const mkAppStore = Record({
  sessionStartedAt: DateTime.utc().toISO(),
  storeCreatedAt: DateTime.utc().toISO(),
  isOffline: false,
  serviceWorkerIsRegistered: false,
  serviceWorkerIsRegistering: false,
  serviceWorkerUpdateIsAvailable: undefined,
  awaitingToAutoRefresh: false,
  updateAllFailed: undefined,
  updateAllMessages: undefined,
  isSanitized: undefined,
  csvImportCompleteByClientId: ImmutableMap(),
  csvImportErrorByClientId: ImmutableMap(),
  dbUpdateTrigger: undefined, // dev only hack to trigger DB updates for wdyr
  fetchInProgress: undefined,
});

export const mkShareAcceptData = Record({
  isGranteeNewUser: false,
  granteeEmail: undefined,
  datasetId: undefined,
  used: 1,
});
